import Seo from "@/components/Seo";
import { Container, Section } from "@/components/layout/Section";
import { SITE } from "@/config/site";

const sections = [
  {
    title: "What we collect",
    body: "When you submit an enquiry we collect your name, business email, and — only if you choose to provide them — your phone number, company name, budget range and timeline, together with your project message, country and the page you enquired from. We do not collect payment details, sensitive personal information, or any data beyond what the form asks for.",
  },
  {
    title: "How we use it",
    body: "Your details are used for one purpose: to review your enquiry and respond to you. We store submissions securely so that no enquiry is lost, and so we can continue a conversation you started. We do not add you to marketing lists, and we do not sell, rent or share your information with third parties for their marketing.",
  },
  {
    title: "Email processing",
    body: "Enquiry notifications and confirmations are sent through a transactional email provider acting as our processor. Your email address is used only for correspondence about your enquiry.",
  },
  {
    title: "Retention and your rights",
    body: `Enquiry records are retained while they are relevant to an active or potential engagement. You may ask us at any time to access, correct or delete the personal information we hold about you by emailing ${SITE.email}. We will action verified requests promptly.`,
  },
  {
    title: "Security",
    body: "Submissions are transmitted over HTTPS, validated and sanitised on our servers, and stored with access restricted to authorised team members. Administrative access is authenticated and limited to people who need it to respond to you.",
  },
  {
    title: "International enquiries",
    body: "We serve clients in Australia, India, the USA, the UK, Canada and other markets. Depending on where you are located, your submission may be processed by team members outside your country, always under this policy.",
  },
  {
    title: "Contact",
    body: `Questions about this policy or your data: ${SITE.email}, or write to us at ${SITE.indiaOffice}.`,
  },
];

const Privacy = () => (
  <>
    <Seo
      title="Privacy Policy"
      description="How A2Z Rankings collects, uses, stores and protects the personal information you share through this website."
    />
    <Section testid="privacy-page" className="pt-32 sm:pt-40">
      <Container className="max-w-3xl space-y-12">
        <div className="space-y-5">
          <p className="eyebrow">Legal</p>
          <h1 className="font-display text-3xl font-bold tracking-tight text-brand-snow sm:text-4xl">
            Privacy Policy
          </h1>
          <p className="text-base leading-relaxed text-brand-mist">
            This policy explains what A2Z Rankings collects through this website, why, and the choices you have.
            Last updated: July 2026.
          </p>
        </div>
        <div className="space-y-10" data-testid="privacy-sections">
          {sections.map((s, i) => (
            <section key={s.title} className="space-y-3" data-testid={`privacy-section-${i + 1}`}>
              <h2 className="font-display text-xl font-semibold text-brand-snow">{s.title}</h2>
              <p className="text-sm leading-relaxed text-brand-mist sm:text-base">{s.body}</p>
            </section>
          ))}
        </div>
      </Container>
    </Section>
  </>
);

export default Privacy;
